<template>
  <v-row align="center">
    <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="col-md-12 home-box">
      <PageTitle :title="'Task Info'" class="py-5 pb-1 px-3"></PageTitle>
      <TaskDetails></TaskDetails>
    </div>
    <div class="col-md-12 home-tabs-body">
    </div>
  </v-row>
</template>

<script>

import TaskDetails from "@/components/tasks/TaskDetails";
import { createNamespacedHelpers } from "vuex";
import PageTitle from "@/components/shared/PageTitle";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "TaskInfo",
  components: {
    TaskDetails,
    PageTitle
  },
  data: function () {
    return {
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile"
    })
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    window.scrollTo(0, 0);
  },

  watch: {

  },

  methods: {

  },

};
</script>

  